var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa-color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#2a2a6c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    d: "M8.51,4.78a3.961,3.961,0,0,1-1.33-.24l.22-1a2.485,2.485,0,0,0,1.127.273l.113,0c.332,0,.71-.24.71-.45s-.179-.315-.62-.57l-.014-.008c-.438-.253-1.037-.6-1.037-1.252,0-.9.823-1.53,2-1.53a3.234,3.234,0,0,1,1.11.2l-.21,1A2.327,2.327,0,0,0,9.616.99c-.072,0-.145,0-.217.01-.345.041-.5.225-.5.39,0,.216.269.36.585.527.483.255,1.085.572,1.085,1.3l.021-.02C10.59,4.16,9.773,4.78,8.51,4.78Zm3.209-.039H10.46L12.26.45a.549.549,0,0,1,.508-.34h1l1,4.629h-1.1l-.17-.69H11.97l-.25.69ZM12.96,1.36,12.33,3.1l1.07-.01ZM6.33,4.73H5.14L6.14.1H7.33l-1,4.63Zm-2.65,0H2.4l-1-3.69A.531.531,0,0,0,1.12.63,5.252,5.252,0,0,0,0,.24V.1H2a.556.556,0,0,1,.55.48l.51,2.67L4.4.1H5.62L3.68,4.73Z",
    transform: "translate(4.6 5.59)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.18d97a8cff494f56d457d45cb7eaaced.svg";
export { ForwardRef as ReactComponent };